// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--L1ZnK"};